import dashboard, { en as dashboardEN, ca as dashboardCA } from './i18n/Dashboard/dashboard'

import folders, { en as foldersEN, ca as foldersCA } from './i18n/Folders/folders'

import kimpleFolderCard, { en as kimpleFolderCardEN, ca as kimpleFolderCardCA } from './i18n/KimpleFolders/kimpleFolderCard'
import kimpleFolderContent, { en as kimpleFolderContentEN, ca as kimpleFolderContentCA } from './i18n/KimpleFolders/kimpleFolderContent'
import shareKimpleFolderModal, { en as shareKimpleFolderModalEN, ca as shareKimpleFolderModalCA } from './i18n/KimpleFolders/shareKimpleFolderModal'

import home, { en as homeEN, ca as homeCA } from './i18n/Home/home'
import login, { en as loginEN, ca as loginCA } from './i18n/Home/login'
import contact, { en as contactEN, ca as contactCA } from './i18n/Home/contact'
import resetPassword, { en as resetPasswordEN, ca as resetPasswordCA } from './i18n/Home/reset-password'
import howItWorks, { en as howItWorksEN, ca as howItWorksCA } from './i18n/HowItWorks/howItWorks'
import socialImpact, { en as socialImpactEN, ca as socialImpactCA } from './i18n/SocialImpact/socialImpact'
import foundationContact, { en as foundationContactEN, ca as foundationContactCA } from './i18n/SocialImpact/foundationContact'

import teacher, { en as teacherEN, ca as teacherCA } from './i18n/Resource/teacher'
import student, { en as studentEN, ca as studentCA } from './i18n/Resource/student'
import resourceCard, { en as resourceCardEN, ca as resourceCardCA } from './i18n/Resource/resourceCard'
import sidebar, { en as sidebarEN, ca as sidebarCA } from './i18n/Resource/sidebar'
import presentationTab, { en as presentationTabEN, ca as presentationTabCA } from './i18n/Resource/presentation'
import shareResource, { en as shareResourceEN, ca as shareResourceCA } from './i18n/Resource/share'
import addResource, { en as addResourceEN, ca as addResourceCA } from './i18n/Resource/addResource'
import removeResource, { en as removeResourceEN, ca as removeResourceCA } from './i18n/Resource/removeResource'
import resourceCategory, { en as resourceCategoryEN, ca as resourceCategoryCA } from './i18n/Resource/resourceCategory'
import valuation, { en as valuationEN, ca as valuationCA } from './i18n/Resource/valuation'

import stats, { en as statsEN, ca as statsCA } from './i18n/Stats/stats'

import trial, { en as trialEN, ca as trialCA } from './i18n/Trial/index'
import quote, { en as quoteEN, ca as quoteCA } from './i18n/Trial/quote'
import trialInvite, { en as trialInviteEN, ca as trialInviteCA } from './i18n/Trial/inviteModal'
import activeAccountModal, { en as activeAccountModalEN, ca as activeAccountModalCA } from './i18n/Trial/activeAccountModal'

import register, { en as registerEN, ca as registerCA } from './i18n/Register/index'

import listPrograms, { en as listProgramsEN, ca as listProgramsCA } from './i18n/EducationalPrograms/list'
import detailProgram, { en as detailProgramEN, ca as detailProgramCA } from './i18n/EducationalPrograms/detail'
import shareProgram, { en as shareProgramEN, ca as shareProgramCA } from './i18n/EducationalPrograms/shareProgram'
import informationProgram, { en as informationProgramEN, ca as informationProgramCA } from './i18n/EducationalPrograms/information'
import programCard, { en as programCardEN, ca as programCardCA } from './i18n/EducationalPrograms/programCard'
import searchProgramResults, { en as searchProgramResultsEN, ca as searchProgramResultsCA } from './i18n/EducationalPrograms/searchResults'
import signTerms, { en as signTermsEN, ca as signTermsCA } from './i18n/SignTerms/signTerms'
import preferences, { en as preferencesEN, ca as preferencesCA } from './i18n/Preferences/preferences'

import profile, { en as profileEN, ca as profileCA } from './i18n/Profile/profile'
import team, { en as teamEN, ca as teamCA } from './i18n/Team/team'
import feed, { en as feedEN, ca as feedCA } from './i18n/Feed/feed'

import navbar, { en as navbarEN, ca as navbarCA } from './i18n/navbar'
import kreaSidebar, { en as kreaSidebarEN, ca as kreaSidebarCA } from './i18n/kreaSidebar'
import footer, { en as footerEN, ca as footerCA } from './i18n/footer'
import notFound, { en as notFoundEN, ca as notFoundCA } from './i18n/notFound'
import unauthorized, { en as unauthorizedEN, ca as unauthorizedCA } from './i18n/unauthorized'
import countries, { en as countriesEN, ca as countriesCA } from './i18n/countries'
import errors, { en as errorsEN, ca as errorsCA } from './i18n/errors'
import faqs, { en as faqsEN, ca as faqsCA } from './i18n/faqs'
import customToast, { en as customToastEN, ca as customToastCA } from './i18n/customToast'
import activateTutorialModal, { en as activateTutorialModalEN, ca as activateTutorialModalCA } from './i18n/activateTutorialModal'
import userRoles, { en as userRolesEN, ca as userRolesCA } from './i18n/userRoles'
import educationalLevels, { en as educationalLevelsEN, ca as educationalLevelsCA } from './i18n/educationalLevels'
import teamStatus, { en as teamStatusEN, ca as teamStatusCA } from './i18n/teamStatus'
import inviteUsersModal, { en as inviteUsersModalEN, ca as inviteUsersModalCA } from './i18n/inviteUsersModal'
import createSharingGroupModal, { en as createSharingGroupModalEN, ca as createSharingGroupModalCA } from './i18n/createSharingGroupModal'
import editSharingGroupModal, { en as editSharingGroupModalEN, ca as editSharingGroupModalCA } from './i18n/editSharingGroupModal'
import addSharingGroupMembersModal, { en as addSharingGroupMembersModalEN, ca as addSharingGroupMembersModalCA } from './i18n/addSharingGroupMembersModal'
import paginatedTable, { en as paginatedTableEN, ca as paginatedTableCA } from './i18n/paginatedTable'
import tagSelector, { en as tagSelectorEN, ca as tagSelectorCA } from './i18n/tagSelector'
import notifications, { en as notificationsEN, ca as notificationsCA } from './i18n/Notifications/notifications'
import usedContent, { en as usedContentEN, ca as usedContentCA } from './i18n/UsedContent/usedContent'
import academicGrades, { en as academicGradesEN, ca as academicGradesCA } from './i18n/academicGrades'

import token, { en as tokenEN, ca as tokenCA } from './i18n/Token'
import onboarding, { en as onboardingEN, ca as onboardingCA } from './i18n/onboarding'
import licenses, { en as licensesEN, ca as licensesCA } from './i18n/licenses'
import content, { en as contentEN, ca as contentCA } from './i18n/contentLanding'
import krea, { en as kreaEN, ca as kreaCA } from './i18n/Krea/krea'
import choiceModal, { en as choiceModalEN, ca as choiceModalCA } from './i18n/choiceModal'
import orderResourcesModal, { en as orderResourcesModalEN, ca as orderResourcesModalCA } from './i18n/orderResourcesModal'
import tiptap, { en as tiptapEN, ca as tiptapCA } from './i18n/tiptap'
import inputs, { en as inputsEN, ca as inputsCA } from './i18n/inputs'
import languages, { en as languagesEN, ca as languagesCA } from './i18n/languages'
import inProgress, { en as inProgressEN, ca as inProgressCA } from './i18n/inProgress'
import kreaContentImageModal, { en as kreaContentImageModalEN, ca as kreaContentImageModalCA } from './i18n/kreaContentImageModal'
import cropImageModal, { en as cropImageModalEN, ca as cropImageModalCA } from './i18n/cropImageModal'
import registerUseModal, { en as registerUseModalEN, ca as registerUseModalCA } from './i18n/registerUseModal'

import { locales } from '../constants/languages'
import sdg, { en as sdgEN, ca as sdgCA } from './i18n/sdg'
import subjects, { en as subjectsEN, ca as subjectsCA } from './i18n/subjects'
import skills, { en as skillsEN, ca as skillsCA } from './i18n/skills'
import topics, { en as topicsEN, ca as topicsCA } from './i18n/topics'
import evaluationMethods, { en as evaluationMethodsEN, ca as evaluationMethodsCA } from './i18n/evaluationMethods'
import udls, { en as udlsEN, ca as udlsCA } from './i18n/udls'
import kreaCreateInTeamModal, { en as kreaCreateInTeamModalEN, ca as kreaCreateInTeamModalCA } from './i18n/kreaCreateInTeamModal'
import authorInfo, { en as authorInfoEN, ca as authorInfoCA } from './i18n/authorInfo'

export const messages = {
  [locales.spanish]: {
    categories: {
      programming: 'Pensamiento computacional',
      citizenship: 'Ciudadanía global',
      enteprenourship: 'Espíritu emprendedor'
    },
    dashboard,
    folders,
    home,
    login,
    contact,
    teacher,
    student,
    presentationTab,
    valuation,
    resourceCard,
    programCard,
    stats,
    navbar,
    footer,
    sidebar,
    shareResource,
    shareProgram,
    addResource,
    removeResource,
    resourceCategory,
    listPrograms,
    resetPassword,
    detailProgram,
    informationProgram,
    profile,
    register,
    notFound,
    countries,
    errors,
    content,
    howItWorks,
    socialImpact,
    foundationContact,
    trial,
    trialInvite,
    faqs,
    quote,
    token,
    onboarding,
    activeAccountModal,
    licenses,
    searchProgramResults,
    kimpleFolderCard,
    signTerms,
    kreaSidebar,
    krea,
    kimpleFolderContent,
    customToast,
    choiceModal,
    tiptap,
    shareKimpleFolderModal,
    inputs,
    unauthorized,
    languages,
    preferences,
    activateTutorialModal,
    team,
    userRoles,
    educationalLevels,
    teamStatus,
    inviteUsersModal,
    paginatedTable,
    tagSelector,
    orderResourcesModal,
    inProgress,
    createSharingGroupModal,
    editSharingGroupModal,
    addSharingGroupMembersModal,
    kreaContentImageModal,
    cropImageModal,
    notifications,
    registerUseModal,
    academicGrades,
    usedContent,
    feed,
    sdg,
    subjects,
    skills,
    topics,
    evaluationMethods,
    udls,
    kreaCreateInTeamModal,
    authorInfo
  },
  [locales.english]: {
    categories: {
      programming: 'Computational Thinking',
      citizenship: 'Global Citizenship',
      enteprenourship: 'Entrepreneurial Spirit'
    },
    dashboard: dashboardEN,
    folders: foldersEN,
    home: homeEN,
    login: loginEN,
    contact: contactEN,
    teacher: teacherEN,
    valuation: valuationEN,
    student: studentEN,
    presentationTab: presentationTabEN,
    resourceCard: resourceCardEN,
    programCard: programCardEN,
    stats: statsEN,
    navbar: navbarEN,
    footer: footerEN,
    sidebar: sidebarEN,
    shareResource: shareResourceEN,
    shareProgram: shareProgramEN,
    addResource: addResourceEN,
    removeResource: removeResourceEN,
    resourceCategory: resourceCategoryEN,
    listPrograms: listProgramsEN,
    resetPassword: resetPasswordEN,
    detailProgram: detailProgramEN,
    informationProgram: informationProgramEN,
    profile: profileEN,
    register: registerEN,
    notFound: notFoundEN,
    countries: countriesEN,
    errors: errorsEN,
    content: contentEN,
    howItWorks: howItWorksEN,
    socialImpact: socialImpactEN,
    foundationContact: foundationContactEN,
    trial: trialEN,
    trialInvite: trialInviteEN,
    faqs: faqsEN,
    quote: quoteEN,
    token: tokenEN,
    onboarding: onboardingEN,
    activeAccountModal: activeAccountModalEN,
    licenses: licensesEN,
    searchProgramResults: searchProgramResultsEN,
    kimpleFolderCard: kimpleFolderCardEN,
    signTerms: signTermsEN,
    kreaSidebar: kreaSidebarEN,
    krea: kreaEN,
    kimpleFolderContent: kimpleFolderContentEN,
    customToast: customToastEN,
    choiceModal: choiceModalEN,
    tiptap: tiptapEN,
    shareKimpleFolderModal: shareKimpleFolderModalEN,
    inputs: inputsEN,
    unauthorized: unauthorizedEN,
    languages: languagesEN,
    preferences: preferencesEN,
    activateTutorialModal: activateTutorialModalEN,
    team: teamEN,
    userRoles: userRolesEN,
    educationalLevels: educationalLevelsEN,
    teamStatus: teamStatusEN,
    inviteUsersModal: inviteUsersModalEN,
    paginatedTable: paginatedTableEN,
    tagSelector: tagSelectorEN,
    orderResourcesModal: orderResourcesModalEN,
    inProgress: inProgressEN,
    createSharingGroupModal: createSharingGroupModalEN,
    editSharingGroupModal: editSharingGroupModalEN,
    addSharingGroupMembersModal: addSharingGroupMembersModalEN,
    kreaContentImageModal: kreaContentImageModalEN,
    cropImageModal: cropImageModalEN,
    notifications: notificationsEN,
    registerUseModal: registerUseModalEN,
    academicGrades: academicGradesEN,
    usedContent: usedContentEN,
    feed: feedEN,
    sdg: sdgEN,
    subjects: subjectsEN,
    skills: skillsEN,
    topics: topicsEN,
    evaluationMethods: evaluationMethodsEN,
    udls: udlsEN,
    kreaCreateInTeamModal: kreaCreateInTeamModalEN,
    authorInfo: authorInfoEN
  },
  [locales.catalan]: {
    categories: {
      programming: 'Pensament computacional',
      citizenship: 'Ciutadania global',
      enteprenourship: 'Esperit emprenedor'
    },
    dashboard: dashboardCA,
    folders: foldersCA,
    home: homeCA,
    login: loginCA,
    contact: contactCA,
    teacher: teacherCA,
    student: studentCA,
    valuation: valuationCA,
    presentationTab: presentationTabCA,
    resourceCard: resourceCardCA,
    programCard: programCardCA,
    stats: statsCA,
    navbar: navbarCA,
    footer: footerCA,
    sidebar: sidebarCA,
    shareResource: shareResourceCA,
    shareProgram: shareProgramCA,
    addResource: addResourceCA,
    removeResource: removeResourceCA,
    resourceCategory: resourceCategoryCA,
    listPrograms: listProgramsCA,
    resetPassword: resetPasswordCA,
    detailProgram: detailProgramCA,
    informationProgram: informationProgramCA,
    profile: profileCA,
    register: registerCA,
    notFound: notFoundCA,
    countries: countriesCA,
    errors: errorsCA,
    content: contentCA,
    howItWorks: howItWorksCA,
    socialImpact: socialImpactCA,
    foundationContact: foundationContactCA,
    trial: trialCA,
    trialInvite: trialInviteCA,
    faqs: faqsCA,
    quote: quoteCA,
    token: tokenCA,
    onboarding: onboardingCA,
    activeAccountModal: activeAccountModalCA,
    licenses: licensesCA,
    searchProgramResults: searchProgramResultsCA,
    kimpleFolderCard: kimpleFolderCardCA,
    signTerms: signTermsCA,
    kreaSidebar: kreaSidebarCA,
    krea: kreaCA,
    kimpleFolderContent: kimpleFolderContentCA,
    customToast: customToastCA,
    choiceModal: choiceModalCA,
    tiptap: tiptapCA,
    shareKimpleFolderModal: shareKimpleFolderModalCA,
    inputs: inputsCA,
    unauthorized: unauthorizedCA,
    languages: languagesCA,
    preferences: preferencesCA,
    activateTutorialModal: activateTutorialModalCA,
    team: teamCA,
    userRoles: userRolesCA,
    educationalLevels: educationalLevelsCA,
    teamStatus: teamStatusCA,
    inviteUsersModal: inviteUsersModalCA,
    paginatedTable: paginatedTableCA,
    tagSelector: tagSelectorCA,
    orderResourcesModal: orderResourcesModalCA,
    inProgress: inProgressCA,
    createSharingGroupModal: createSharingGroupModalCA,
    editSharingGroupModal: editSharingGroupModalCA,
    addSharingGroupMembersModal: addSharingGroupMembersModalCA,
    kreaContentImageModal: kreaContentImageModalCA,
    cropImageModal: cropImageModalCA,
    notifications: notificationsCA,
    registerUseModal: registerUseModalCA,
    academicGrades: academicGradesCA,
    usedContent: usedContentCA,
    feed: feedCA,
    sdg: sdgCA,
    subjects: subjectsCA,
    skills: skillsCA,
    topics: topicsCA,
    evaluationMethods: evaluationMethodsCA,
    udls: udlsCA,
    kreaCreateInTeamModal: kreaCreateInTeamModalCA,
    authorInfo: authorInfoCA
  }
}
